
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_939hXVp502_D89VcEb5MYNHaV28voQsqU_Ko7ro6SIvb4Meta } from "D:/my-projects/vue-app/nuxt-app/app/pages/[...slug].vue?macro=true";
import { default as index6oxnnL4KsdjVl_6i_ASP9WCF2sfpWXHPC79fUYf2jJAMeta } from "D:/my-projects/vue-app/nuxt-app/app/pages/home/index.vue?macro=true";
import { default as indexaeNYUQLyhocsg1YKh79k51mYWrVexLosx_9D4bbShqoMeta } from "D:/my-projects/vue-app/nuxt-app/app/pages/login/index.vue?macro=true";
import { default as indexT68PnkRoFKYO_mj6X8qBAk1Wf6a26au7dugPoB5Aa1oMeta } from "D:/my-projects/vue-app/nuxt-app/app/pages/articles/index.vue?macro=true";
import { default as _91_46_46_46slug_93IkuSbwLRomOUPpGCCS8V8jju9m3ISZpLZo6T1B5sCHkMeta } from "D:/my-projects/vue-app/nuxt-app/app/pages/articles/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_939hXVp502_D89VcEb5MYNHaV28voQsqU_Ko7ro6SIvb4Meta || {},
    component: () => import("D:/my-projects/vue-app/nuxt-app/app/pages/[...slug].vue")
  },
  {
    name: "home",
    path: "/home",
    meta: index6oxnnL4KsdjVl_6i_ASP9WCF2sfpWXHPC79fUYf2jJAMeta || {},
    component: () => import("D:/my-projects/vue-app/nuxt-app/app/pages/home/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexaeNYUQLyhocsg1YKh79k51mYWrVexLosx_9D4bbShqoMeta || {},
    component: () => import("D:/my-projects/vue-app/nuxt-app/app/pages/login/index.vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: indexT68PnkRoFKYO_mj6X8qBAk1Wf6a26au7dugPoB5Aa1oMeta || {},
    component: () => import("D:/my-projects/vue-app/nuxt-app/app/pages/articles/index.vue")
  },
  {
    name: "articles-slug",
    path: "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93IkuSbwLRomOUPpGCCS8V8jju9m3ISZpLZo6T1B5sCHkMeta || {},
    component: () => import("D:/my-projects/vue-app/nuxt-app/app/pages/articles/[...slug].vue")
  }
]